function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "20",
  cy: "20",
  fill: "#d8d8d8",
  r: "11"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.462 2.335a.902.902 0 00-.955.183l-3.641 3.535C30.955 2.151 25.733 0 20.162 0c-1.177 0-2.367.098-3.532.298C8.691 1.637 2.262 7.4.248 14.988a.842.842 0 00.156.734c.168.209.42.331.693.331h5.58a.88.88 0 00.824-.559c1.632-4.339 5.689-7.645 10.336-8.429.765-.13 1.543-.196 2.316-.196 3.692 0 7.14 1.433 9.709 4.041l-3.7 3.592a.838.838 0 00-.189.927.874.874 0 00.807.526h12.345a.861.861 0 00.875-.849V3.118a.838.838 0 00-.538-.783z",
  "data-bx-origin": "-0.660719 -0.618451"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.907 23.951h-5.58a.88.88 0 00-.824.559c-1.632 4.335-5.689 7.641-10.335 8.425-.766.13-1.544.196-2.317.196-3.692 0-7.14-1.433-9.709-4.041l3.7-3.592a.831.831 0 00.189-.927.874.874 0 00-.807-.526H.875a.861.861 0 00-.875.849v11.984c0 .342.214.653.542.787a.903.903 0 00.955-.183l3.641-3.535C9.044 37.849 14.267 40 19.842 40a21.4 21.4 0 003.536-.298c7.935-1.335 14.36-7.102 16.374-14.69a.842.842 0 00-.156-.734.885.885 0 00-.689-.327z",
  "data-bx-origin": "-0.655168 -2.110973"
}))));